import type { AdEnginePlugin } from "./core/AdEnginePlugin";
import { getBooleanQueryParam, hasQueryParam } from "utils";

/**
 * Checks if the isAdTestWiki property is set to true on the ads context on the page.
 * @returns true if this is a test wiki
 */
function isTestWiki(): boolean {
  return window.ads?.context?.opts?.isAdTestWiki === true;
}

export async function debug() {
  const debugPlugins: AdEnginePlugin[] = [];
  const isPassCIDPluginEnabled = hasQueryParam("cid");

  if (isPassCIDPluginEnabled) {
    const { PassCIDPlugin } = await import(
      "./plugins/debug/PassCIDPlugin/PassCIDPlugin"
    );
    debugPlugins.push(new PassCIDPlugin());
  }

  const isGPTDebugPluginEnabled = getBooleanQueryParam("gpt_debug");
  if (isGPTDebugPluginEnabled) {
    const { GPTDebugPlugin } = await import(
      "./plugins/debug/GPTDebugPlugin/GPTDebugPlugin"
    );
    debugPlugins.push(new GPTDebugPlugin());
  }

  const isPrebidWikiaDebugPluginEnabled =
    hasQueryParam("wikia_bidder") || hasQueryParam("pbjs_mock");
  if (isPrebidWikiaDebugPluginEnabled) {
    const { PrebidWikiaDebugPlugin } = await import(
      "./plugins/debug/PrebidWikiaDebugPlugin/PrebidWikiaDebugPlugin"
    );
    debugPlugins.push(new PrebidWikiaDebugPlugin());
  }

  if (getBooleanQueryParam("bidder_debug")) {
    const { BidderDebugPlugin } = await import(
      "./plugins/debug/BidderDebugPlugin/BidderDebugPlugin"
    );
    debugPlugins.push(new BidderDebugPlugin());
  }

  // If the ads context opts.isAdTestWiki exists and is set to true, load the test wiki plugin to
  // configure the engine specifically for test wikis. You can opt out of setting src to test using
  // query param or cookie for `skip_src_test`
  if (isTestWiki()) {
    const { TestWikiPlugin } = await import(
      "./plugins/debug/TestWikiPlugin/TestWikiPlugin"
    );
    debugPlugins.push(new TestWikiPlugin());
  }

  return debugPlugins;
}
